export class PresupuestosEstadosConstants {
    static readonly SOLICITUD = 'solicitud';
    static readonly ENVIADO = 'enviado';
    static readonly ACEPTADO = 'aceptado';
    static readonly RECHAZADO = 'rechazado';
}